// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"590":"f0943c4e1d3195ea71d7","972":"2e38a8b31088c906894e"}[chunkId] + ".css";
};